// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_dt-0";
export var headerCellHover = "_dt-1";